import { useCallback, useMemo, useState } from 'react'

import { AutocompleteInputChangeReason } from '@mui/material'

import { useDebouncedValue } from '@collaborate-health/uikit'
import { FormAutocomplete, FormAutocompleteProps } from '@collaborate-health/forms'

import { useQualificationSearch } from '../../../hooks'

export interface QualificationsAutocompleteProps {
  name?: string
  multiple?: boolean
}

const QualificationsAutocomplete: React.FC<QualificationsAutocompleteProps> = ({
  name = 'Qualifications',
  multiple = true,
}) => {
  const [searchTextQualification, setSearchTextQualification] = useState('')
  const debouncedSearchQualifications = useDebouncedValue(searchTextQualification, 500)

  const handleChangeSearchQualifications = useCallback((e, value: string, reason: AutocompleteInputChangeReason) => {
    if (reason === 'reset') {
      setSearchTextQualification('')
    } else if (reason === 'input') {
      setSearchTextQualification(value)
    }
  }, [])

  const { loading, qualifications } = useQualificationSearch(debouncedSearchQualifications)

  const options = useMemo<FormAutocompleteProps<number>['options']>(() => {
    if (!qualifications) {
      return []
    }

    return qualifications.map((q) => ({ value: q.Id, name: q.Name, meta: q }))
  }, [qualifications])

  return (
    <FormAutocomplete
      name={name}
      valueMode='object'
      multiple={multiple}
      loading={loading}
      options={options}
      label='Qualifications'
      placeholder='Search qualification name...'
      onInputChange={handleChangeSearchQualifications}
    />
  )
}

export default QualificationsAutocomplete

